export const API_URL = 'https://ipqf.test.ares.empeek.net/api';
export const API_AUTHORIZATION_URL = `${API_URL}/Token`;
